import { AccountTypeID } from "../../config/Constants"
import { ObservableFromFetch } from "../ObservableFromFetch"
import PhoneType from "../PhoneType"
import ServiceDetails from "./OrderResultModel/ServiceDetails"
import TestEventUpdateData from "./OrderResultModel/TestEventUpdateData"

interface CurrentServiceDetailsParams {
  AccountTypeID?: number
  TestDetailClinicalID?: string
  TestDetailID?: string
  CompareMode?:boolean
}

function requestParams(options: CurrentServiceDetailsParams) {
  return JSON.stringify({
    AccountTypeID: AccountTypeID,
    TestDetailClinicalID: options.TestDetailClinicalID,
    TestDetailID: options.TestDetailID,
    CompareMode:false
  })
}
function requestParamsForCompare(options: CurrentServiceDetailsParams) {
  return JSON.stringify({
    AccountTypeID: AccountTypeID,
    TestDetailClinicalID: options.TestDetailClinicalID,
    TestDetailID: options.TestDetailID,
    CompareMode:true
  })
}

export const CurrentServiceDetails = (params: CurrentServiceDetailsParams) => ObservableFromFetch<ServiceDetails>("WorkforceTrack/GetCurrentServiceDetail", requestParams(params))
export const CurrentServiceDetailsForCompare = (params: CurrentServiceDetailsParams) => ObservableFromFetch<ServiceDetails>("WorkforceTrack/GetCurrentServiceDetail", requestParamsForCompare(params))

export const UpdateServiceData = (params: TestEventUpdateData) => {
  const requestBody = JSON.stringify({
    TestEventID: params.TestEventID,
    FormFoxTestAN: params.FormFoxTestAN,
    PersonnelID: params.PersonnelID,
    IDType: params.IDType,
    FirstName: params.FirstName,
    LastName: params.LastName,
    HomePhone: params.Phones[PhoneType.Home].number,
    WorkPhone: params.Phones[PhoneType.Work].number,
    CellPhone: params.Phones[PhoneType.Cell].number,
    RegulatoryModeID: params.RegulatoryModeID,
    EmployeeCategoryID: params.EmployeeCategoryID,
  })
  return ObservableFromFetch<string>("WorkforceTrack/UpdateCurrentServiceDetail", requestBody)
}

interface ResolveAlertData{
  TestEventAlertID: string
}

export const ResolveAlert = (params: ResolveAlertData) => {
  const requestBody = JSON.stringify({
    TestEventAlertID: params.TestEventAlertID
  })
  return ObservableFromFetch<string>("WorkforceTrack/ResolveAlert", requestBody)
}
